import { IDateInterval } from "@components/inputs/date/utils";
import SelectionTableViewDialog from "@components/smart/selectionTableView/SelectionTableViewDialog";
import { TSmartODataTableStorage } from "@components/smart/smartTable/SmartODataTableBase";
import BindingContext, { IEntity } from "@odata/BindingContext";
import { WithOData, withOData } from "@odata/withOData";
import { getDefinitionsFactory, PairCancelReapplyTableCustomData } from "@pages/electronicSubmission/CancelReapplyDef";
import CancelReapplyPairTableView from "@pages/electronicSubmission/CancelReapplyPairTableView";
import { getCancelReapplyTranslation, TCancelOrReapply } from "@pages/electronicSubmission/VatSubmission.utils";
import { memoizeOne } from "@utils/memoizeOne";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { AppContext } from "../../contexts/appContext/AppContext.types";
import i18next from "../../i18n";
import { TableStorage } from "../../model/TableStorage";

interface IProps extends WithTranslation, WithOData {
    type: TCancelOrReapply;
    isProcessed: boolean;
    period: IDateInterval;
    onClose: (hasChanged: boolean) => void;
    isDisabled?: boolean;
}

class CancelReapplyDialog extends React.Component<IProps> {
    static contextType = AppContext;

    _hasChanged = false;
    _loaded = false;

    componentDidMount() {
        // load translation files from def
        this.initDefinition();
    }

    getDefinition = memoizeOne(() => {
        return getDefinitionsFactory(this.props.type, this.props.isProcessed, this.props.period);
    }, () => [this.props.type, this.props.isProcessed, this.props.period, this.props.period]);

    async initDefinition() {
        await i18next.loadNamespaces(this.getDefinition().translationFiles);
        this._loaded = true;
        this.forceUpdate();
    }

    handleDataChanged = async (selected: BindingContext[], entities: IEntity[], storage?: TSmartODataTableStorage) => {
        if (selected.length) {
            this._hasChanged = true;
        }
    }

    handleClose = () => {
        this.props.onClose(this._hasChanged);
    }

    get title() {
        const { isProcessed, type } = this.props;
        return getCancelReapplyTranslation("Title", { isProcessed, type });
    }

    initStorage = (storage: TableStorage) => {
        (storage as unknown as TSmartODataTableStorage<PairCancelReapplyTableCustomData>).setCustomData({
            isProcessed: this.props.isProcessed,
            period: this.props.period,
            type: this.props.type
        });
    }

    render() {
        if (!this._loaded) {
            return null;
        }
        return (
                <SelectionTableViewDialog
                        oData={this.props.oData}
                        t={this.props.t}
                        tableView={CancelReapplyPairTableView}
                        getDefinition={this.getDefinition()}
                        title={this.title}
                        initializeStorage={this.initStorage}
                        onSelection={this.handleDataChanged}
                        onClose={this.handleClose}
                        isSingleSelect={false}/>
        );
    }
}

export default withTranslation(["ElectronicSubmission", "Common"])(withOData(CancelReapplyDialog));
